import { Component, OnInit, Input } from '@angular/core';
import { MatTreeFlatDataSource, MatTreeFlattener } from '@angular/material/tree';
import { FlatTreeControl } from '@angular/cdk/tree';

interface JsonTreeNode {
  name: string;
  value?: any;
  children?: JsonTreeNode[];
}

@Component({
  selector: 'aw-json-tree',
  templateUrl: './json-tree.component.html',
  styleUrls: ['./json-tree.component.scss']
})
export class JsonTreeComponent implements OnInit {
  @Input() jsonData: any;

  private _transformer = (node: JsonTreeNode, level: number) => {
    return {
      expandable: !!node.children && node.children.length > 0,
      name: node.name,
      value: node.value,
      level: level,
    };
  };

  treeControl = new FlatTreeControl<any>(
    node => node.level,
    node => node.expandable
  );

  treeFlattener = new MatTreeFlattener(
    this._transformer,
    node => node.level,
    node => node.expandable,
    node => node.children
  );

  dataSource = new MatTreeFlatDataSource(this.treeControl, this.treeFlattener);

  constructor() {}

  ngOnInit() {
    this.dataSource.data = this.buildTree(this.jsonData, 0);
  }

  hasChild = (_: number, node: any) => node.expandable;

  buildTree(obj: any, level: number): JsonTreeNode[] {
    if (Array.isArray(obj)) {
      return obj.map((value, index) => {
        const node: JsonTreeNode = { name: `${index}` };
        if (value != null && typeof value === 'object') {
          node.children = this.buildTree(value, level + 1);
        } else {
          node.value = value;
        }
        return node;
      });
    } else {
      return Object.keys(obj).map(key => {
        const value = obj[key];
        const node: JsonTreeNode = { name: key };
        if (value != null && typeof value === 'object') {
          node.children = this.buildTree(value, level + 1);
        } else {
          node.value = value;
        }
        return node;
      });
    }
  }
}
